/**
 * 产品锁紧组合：锋利三角徽标 + Inter Medium「TK-Master」字标。
 *
 * Callers: 顶栏、认证壳、设置页、onboarding
 *
 * Modules:
 * - BrandMark — 展开显示词标；showTagline 显示副标；compact 只留徽标
 */

import { useAppI18n } from "@/i18n/context";

import { GlitchSlashMark } from "./glitch-slash-mark";

export function BrandMark({
  compact = false,
  showTagline = false,
}: {
  compact?: boolean;
  showTagline?: boolean;
}) {
  const { t } = useAppI18n();

  return (
    <div className="brand-mark">
      <span className="brand-mark__icon" aria-hidden="true">
        <GlitchSlashMark />
      </span>
      {!compact ? (
        <span className="brand-mark__text">
          <span className="brand-mark__wordmark">TK-Master</span>
          {showTagline ? (
            <span className="brand-mark__tagline">{t("shell.brandTagline")}</span>
          ) : null}
        </span>
      ) : null}
    </div>
  );
}
